import { useTranslation } from 'react-i18next';

const FamilyBuildingAdoptionSupport = ({ prevStep, handleChange, formData, nextStep,error,step, totalSteps, isHighmarkPortal }) => {
  const { t } = useTranslation();
  const supportOptions = [
    "Understanding my benefits and coverage",
    "Finding a vetted agency or attorney",
    "Financial planning and reimbursements",
    "Emotional or mental health support",
    "Education about the adoption process",
    "Timeline and next step guidance",
  ];

  const selectedSupportOptions = Array.isArray(formData.AdoptionSupport)
    ? formData.AdoptionSupport
    : formData.AdoptionSupport
    ? [formData.AdoptionSupport]
    : [];

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    const updatedSelections = checked
      ? [...selectedSupportOptions, value]
      : selectedSupportOptions.filter((item) => item !== value);

    handleChange({
      target: {
        name: 'AdoptionSupport',
        value: updatedSelections,
      },
    });
  };

  return (
    <>
      <div className="step-section">
        <div className="adoption-journey-label">Adoption Journey</div>
        <h3 className="page-heading-secondary-black-500 mb-5">What type of support would be more helpful right now?</h3>
        {supportOptions.map((option, index) => {
          const optionId = `adoptionSupport${index + 1}`;

          return (
            <div key={option} className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
              <input
                type="checkbox"
                className="form-check-input radio-btn win-form-check-input"
                name="AdoptionSupport"
                id={optionId}
                value={option}
                checked={selectedSupportOptions.includes(option)}
                onChange={handleCheckboxChange}
              />
              <label htmlFor={optionId} className="multistep-form-radio-checkbox-label">{option}</label>
            </div>
          );
        })}
        {error && <p className="text-danger">{error}</p>}
        {/* Navigation Buttons */}
        <div className="mt-5">
  {isHighmarkPortal ? (
    <div className="pagination-wrapper mt-5">
      <button className="previous-btn" onClick={prevStep}></button>
      <span className="me-3">{step} of {totalSteps}</span>
      <button className="next-btn" onClick={nextStep}></button>
    </div>
  ) : (
    <>
      <button className="win-btn-secondary mobile-view me-3 mb-2 mb-md-0" onClick={prevStep}>
        {t('back')}
      </button>
      <button className="win-btn-primary mobile-view mb-3" onClick={nextStep}>{t('next')}</button>
    </>
  )}
</div>

      </div>
    </>
  );
};

export default FamilyBuildingAdoptionSupport;
